import appConfig from '@/config/applicationConfig.js'

export const locale = appConfig.LOCALE

export const formatDate = (string, options = {}, utc = true) => (
  new Date(`${string}${utc ? 'Z' : ''}`).toLocaleDateString(locale, { ...options })
)

export const formatTime = (string, options = {}, utc = true) => (
  new Date(`${string}${utc ? 'Z' : ''}`).toLocaleTimeString(locale, { hour12: false, ...options })
)

export const formatDateTime = (string, dateOptions = {}, timeOptions = {}) => (
  `${formatDate(string, dateOptions)} ${formatTime(string, timeOptions)}`
)